import { NgModule } from '@angular/core';
import { AutosizeDirective } from './autosize/autosize';
import { HideHeaderDirective } from './hide-header/hide-header';
@NgModule({
	declarations: [
		AutosizeDirective,
    HideHeaderDirective
	],
	imports: [],
	exports: [
		AutosizeDirective,
    HideHeaderDirective
	]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts